export default __webpack_public_path__ + "static/media/brand_clubdeleste.0b918ace.svg";